const filtroBusquedaRAState = {
  loading: false,
  loadingFileArancelCompleto: false,
  loadingFileArancelSeleccionado: false,
  infoExpanded: true,
  busquedaarancelesDetalle: false,
  solicitudEnCurso: false,
  arancelesDetalle: [],

  periodoReajuste: {
    FechaVigencia: null,
    FechaVigenciaError: null,

    FechaInicio: null,
    FechaTermino: null,
    ValorReajuste: null,
    Validado: null,
    PeriocidadUnidad: null,
  },

  periodoReajustePQ: {
    FechaVigencia: null,
    FechaVigenciaError: null,

    FechaInicio: null,
    FechaTermino: null,
    ValorReajuste: null,
    Validado: null,
    PeriocidadUnidad: null,
  },

  historialReajustes: [],
};

export default filtroBusquedaRAState;
